import { Injectable } from '@angular/core';
import { InterfaceNameValue } from '@common/interfaces/issueTypeInterface';
import { IMetaInterfaces } from '@common/interfaces/metaInterfaces';
import { Topics } from '@common/interfaces/topics';
import { MetaIntyerfacePemissionType } from '@ep-om/project/components/interfaces/_meta-interface/meta-interface.component';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { IssueQuery } from '../issue/issue.query';
import { MetaInterfacesUpdateStoreStrategy } from '../updateStoreStrategies';
import { WorkflowQuery } from '../workflow/workflow.query';
import { MetaInterfacesQuery } from './metaInterfaces.query';
import { MetaInterfacesStore } from './metaInterfaces.store';


@Injectable({
  providedIn: 'root'
})
export class MetainterfacesService extends CrudService<IMetaInterfaces, MetaInterfacesStore,MetaInterfacesQuery> {
  constructor(
    public store: MetaInterfacesStore,
    public query: MetaInterfacesQuery,
    protected updateStrategy: MetaInterfacesUpdateStoreStrategy,
    protected actionService: ActionService,
    private workflowQuery: WorkflowQuery,
    private issueQuery: IssueQuery
  ) {
    super(
      Topics.INTERFACES,
      store,
      query,
      actionService,
      updateStrategy
    );
  }
}
